import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { firestore, collection, getDocs, query, where } from './firebase-config';
import './Blog.css';

const BlogPost = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => {
    const fetchPost = async () => {
      const q = query(collection(firestore, 'blogPosts'), where('slug', '==', slug));
      const snapshot = await getDocs(q);
      if (!snapshot.empty) {
        setPost(snapshot.docs[0].data());
      }
    };
    fetchPost();
  }, [slug]);

  if (!post) return <p>Loading...</p>;

  return (
    <div className="blog-post">
      {/* <h1>{post.title}</h1> */}
      {/* <p><i>By {post.author} — {new Date(post.publishedAt.seconds * 1000).toDateString()}</i></p> */}
      <div dangerouslySetInnerHTML={{ __html: post.content }} />
    </div>
  );
};

export default BlogPost;
